module.exports = __webpack_public_path__ + "bfee0fa56abfe387ae4783aeb3267a55.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/styles/medium/public/games/sm_image_1.jpg
// module id = 516
// module chunks = 0